import Link from '@mui/material/Link';
import {usePatAuth} from "../context/PatAuthContext";
import React, {useState} from "react";
import {Box, Button, CssBaseline, Paper, TextField, Typography} from "@mui/material";
import {createTheme, ThemeProvider} from "@mui/material/styles";
const theme = createTheme({
    typography: {
        fontFamily: `"Inter", "SF Pro Display", "Segoe UI", sans-serif`,
    },
});
function PatLogin() {
    const {loginPatient} = usePatAuth();
    const [formError, setFormError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [loginData, setLoginData] = useState({
        hospital_code: "", username: "", password: "",
    });
    const inputHandler = (event) => {
        setLoginData({
            ...loginData, [event.target.name]: event.target.value
        });
    };
    const submitForm = (event) => {
        event.preventDefault();
        loginPatient(event);
    };
    const buttonEnable = loginData.username !== "" && loginData.password !== "" && loginData.hospital_code !== "";
    return (<ThemeProvider theme={theme}>

        <CssBaseline/>


        <Box className="login-page">


            <Paper
                elevation={0}
                className="login-card"
            >
                <Box
                    sx={{
                        display: "flex", flexDirection: "column", alignItems: "center"
                    }}
                >


                    {/* LOGO */}


                    <Box className="login-logo">

                        <img
                            src="/mgm.png"
                            alt="logo"
                        />

                    </Box>


                    {/* TITLE */}

                    <div className="login-title">

                        MGM DrHiS

                    </div>


                    <div className="login-subtitle">

                        Patient Portal

                    </div>


                    {formError && <div className="login-error">

                        {errorMsg}

                    </div>}


                    <Box
                        component="form"
                        onSubmit={submitForm}
                        width="100%"
                    >


                        <TextField

                            fullWidth

                            margin="normal"

                            label="Hospital Code"

                            name="hospital_code"

                            value={loginData.hospital_code}

                            onChange={inputHandler}

                        />


                        <TextField

                            fullWidth

                            margin="normal"

                            label="Patient ID"

                            name="username"

                            value={loginData.username}

                            onChange={inputHandler}

                        />


                        <TextField

                            fullWidth

                            margin="normal"

                            type="password"

                            label="Password"

                            name="password"

                            value={loginData.password}

                            onChange={inputHandler}

                        />


                        <Button

                            type="submit"

                            fullWidth

                            variant="contained"

                            disabled={!buttonEnable}

                        >

                            Sign In

                        </Button>


                    </Box>


                    <Typography

                        sx={{
                            mt: 4, color: "rgba(255,255,255,.5)", fontSize: "13px", textAlign: "center"
                        }}

                    >

                        © {new Date().getFullYear()}{" "}

                        <Link
                            color="inherit"
                            href="https://www.mgmebuild.com/"
                        >

                            MGM eBuild Pvt Ltd

                        </Link>


                    </Typography>

                </Box>


            </Paper>


        </Box>


    </ThemeProvider>);
}
export default PatLogin;